import * as ko from "knockout";
import {PersonaliaModel} from "./PersonaliaModel";
import {IModelParams} from "./index";

export class PersonaliaModelEdit extends PersonaliaModel {

    constructor(params: IModelParams) {
        super(params)

        this.derived.SourceId = ko.pureComputed(() => {
            return this.getOriginalValue('SourceId');
        })

        const employeeNumber = this.attr.EmployeeNumber
        if (employeeNumber) {
            this.kosub.subscribe(employeeNumber, newVal => {
                const originalVal = this.getOriginalValue('EmployeeNumber');
                this.meta.isEmployeeNumberChanged(newVal != originalVal)
            })
        }
    }
}
